module.exports = __webpack_public_path__ + "6be88fea8e4a000b737db11d73db793a.png";